module.exports = __webpack_public_path__ + "static/media/government.e2515c39.png";